import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { isLoadedPrizeWins, TPrizeDisplayItem } from 'constants/WinType';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Monthly10kGiveaway from './Monthly10kGiveaway';
import YourWins from './your-wins/YourWins';

const WinsAndMonthly = observer(({ loading }: { loading?: boolean }) => {
  const {
    unclaimedPrizeWins,
    claimedPrizeWins,
    unclaimedPromoPrizeRewards,
    claimedPromoPrizeRewards,
    getPrizeWinsAndRewards,
  } = useUserStore();
  const [allWins, setAllWins] = useState<TPrizeDisplayItem[]>([]);

  const hasUnclaimedPrizes = Boolean(
    unclaimedPrizeWins !== 'LOADING' &&
      unclaimedPrizeWins !== 'ERROR' &&
      unclaimedPrizeWins.find(
        (win) =>
          'expiresAt' in win && win.expiresAt && win.expiresAt > new Date(),
      ),
  );

  useEffect(() => {
    const allUnclaimed =
      isLoadedPrizeWins(unclaimedPrizeWins) &&
      isLoadedPrizeWins(unclaimedPromoPrizeRewards)
        ? [...unclaimedPrizeWins, ...unclaimedPromoPrizeRewards]
        : [];

    const filteredUnclaimed = allUnclaimed
      .filter(
        (win) =>
          'expiresAt' in win && win.expiresAt && win.expiresAt > new Date(),
      )
      .sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );

    const allClaimed =
      isLoadedPrizeWins(claimedPrizeWins) &&
      isLoadedPrizeWins(claimedPromoPrizeRewards)
        ? [...claimedPrizeWins, ...claimedPromoPrizeRewards]
        : [];

    const filteredClaimed = allClaimed.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    );

    const allWins: TPrizeDisplayItem[] = [
      ...filteredUnclaimed,
      ...filteredClaimed,
    ];

    setAllWins(allWins);
  }, [
    unclaimedPrizeWins,
    claimedPrizeWins,
    unclaimedPromoPrizeRewards,
    claimedPromoPrizeRewards,
  ]);

  const FirstComponent = () => {
    return hasUnclaimedPrizes ? (
      <YourWins
        unclaimedPrizeWins={unclaimedPrizeWins}
        getPrizeWins={getPrizeWinsAndRewards}
        allWins={allWins}
      />
    ) : (
      <Monthly10kGiveaway loading={loading} />
    );
  };

  const SecondComponent = () => {
    return hasUnclaimedPrizes ? (
      <Monthly10kGiveaway loading={loading} />
    ) : (
      <YourWins
        unclaimedPrizeWins={unclaimedPrizeWins}
        getPrizeWins={getPrizeWinsAndRewards}
        allWins={allWins}
      />
    );
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <AboutUsModule background="grey" withReducedPadding>
        <AboutUsSiteContainer overlapBelow={allWins.length === 0}>
          <AboutUsSiteInnerContainer
            background="white"
            borderRadius
            withPadding
          >
            <FirstComponent />
          </AboutUsSiteInnerContainer>
        </AboutUsSiteContainer>
      </AboutUsModule>

      {allWins.length !== 0 ? (
        <AboutUsModule background="grey" withReducedPadding>
          <AboutUsSiteContainer overlapBelow>
            <AboutUsSiteInnerContainer
              background="white"
              borderRadius
              withPadding
            >
              <SecondComponent />
            </AboutUsSiteInnerContainer>
          </AboutUsSiteContainer>
        </AboutUsModule>
      ) : null}
    </>
  );
});

export default WinsAndMonthly;
